/* PD Best Price Care Modal —— pd-best-price 与 pd-more-deals 共享逻辑
   - 自定义 dropdown（trigger + panel + options）替代原生 <select>
   - Care benefits 切换 + 同步同卡内 hidden variant input
   - Compare modal open/close（含 backdrop click 关闭）
   - 通过 html.pd-bp-modal-open 控制 body overflow，避免多 modal 互踩 body.style
   - window.PdBpDropdown.init(el, { onChange }) 暴露给 pd-more-deals.js 复用 */
(function () {
  'use strict';

  // ===== 通用 dropdown =====
  function initDropdown(dd, opts) {
    if (!dd || dd.dataset.pdBpDdInit === '1') return;
    dd.dataset.pdBpDdInit = '1';

    var trigger = dd.querySelector('[data-pd-bp-dd-trigger]');
    var label = dd.querySelector('[data-pd-bp-dd-label]');
    var panel = dd.querySelector('[data-pd-bp-dd-panel]');
    var options = dd.querySelectorAll('[data-pd-bp-dd-option]');
    if (!trigger || !panel) return;

    // JS 接管后移除 hidden 属性（SSR 兜底），交由 .is-open class + CSS 过渡控制可见性
    panel.removeAttribute('hidden');

    function setOpen(open) {
      dd.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!dd.classList.contains('is-open'));
    });

    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = opt.getAttribute('data-value');
        options.forEach(function (o) {
          var sel = o === opt;
          o.classList.toggle('is-selected', sel);
          o.setAttribute('aria-selected', sel ? 'true' : 'false');
        });
        if (label) label.innerHTML = (opt.innerHTML || '').trim();
        setOpen(false);
        if (opts && typeof opts.onChange === 'function') opts.onChange(v);
      });
    });

    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target)) setOpen(false);
    });

    dd.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setOpen(false);
        if (trigger.focus) trigger.focus();
      }
    });
  }

  // 暴露给 pd-more-deals.js 等其它脚本
  window.PdBpDropdown = { init: initDropdown };

  function initCareSelect(dd) {
    if (dd.dataset.pdBpInit === '1') return;
    dd.dataset.pdBpInit = '1';
    var wrap = dd.parentNode.querySelector('[data-pd-bp-care-benefits]');
    var card = dd.closest('[data-pd-md-card], .pd-best-price__card');
    var hiddens = card ? card.querySelectorAll('[data-pd-bp-care-vid-input]') : [];
    initDropdown(dd, {
      onChange: function (idx) {
        var key = String(idx);
        if (wrap) {
          wrap.querySelectorAll('[data-pd-bp-benefit]').forEach(function (el) {
            el.classList.toggle('is-active', el.getAttribute('data-pd-bp-benefit') === key);
          });
        }
        var vid = dd.getAttribute('data-care-vid-' + key) || '';
        hiddens.forEach(function (h) { h.value = vid; });
      }
    });
  }

  function initModal(modal) {
    if (modal.dataset.pdBpInit === '1') return;
    modal.dataset.pdBpInit = '1';

    var section = modal.closest('.shopify-section') || document;
    var lastTrigger = null;

    function openModal(e) {
      if (e) {
        e.preventDefault();
        lastTrigger = e.currentTarget;
      }
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.classList.add('pd-bp-modal-open');
    }

    function closeModal() {
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
        restoreFocus();
      }
      document.documentElement.classList.remove('pd-bp-modal-open');
    }

    function restoreFocus() {
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
    }

    section.querySelectorAll('[data-pd-bp-compare-trigger]').forEach(function (trigger) {
      var targetId = trigger.getAttribute('data-pd-bp-modal-target');
      if (targetId && targetId !== modal.id) return;
      if (!targetId && !modal.hasAttribute('data-pd-bp-modal-default')
        && section.querySelector('[data-pd-bp-modal-default]')) return;
      trigger.addEventListener('click', openModal);
    });

    modal.querySelectorAll('[data-pd-bp-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('pd-bp-modal-open');
      restoreFocus();
    });
  }

  function initIn(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('[data-pd-bp-care-select]').forEach(initCareSelect);
    root.querySelectorAll('[data-pd-bp-modal]').forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initIn(document); });
  } else {
    initIn(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initIn(e.target);
  });
})();
